const subzeroBlue = {
  main: "#0379B9",
  light: "#308dbf",
  dark: "#015380",
};

export { subzeroBlue };
